// extracted by mini-css-extract-plugin
export var Footer = "R_cQ";
export var aniBgLoading = "R_f";
export var aniSpin = "R_d";
export var column = "R_bc";
export var columns = "R_cT";
export var heading = "R_w";
export var link = "R_bd";
export var main = "R_c";
export var nav = "R_bb";
export var newsletter = "R_cV";
export var newsletter__heading = "R_cW";
export var scrollTop = "R_cR";
export var scrollTop__btn = "R_cS";